export default {
    login: 'Login'
}